import { Route } from "react-router-dom";
import Zones from "../pages/Sewa/Zone";
import ChargesReport from "../pages/Sewa/ChargesReport";
import KPIRevenue from "../pages/Sewa/KPIrevenue";
import Rampasan from "../pages/Sewa/Rampasan";
import PaymentByDay from "../pages/Sewa/PaymentReportDay";
import PaymentByWeek from "../pages/Sewa/PaymentReportByWeek";
import PaymentByMonth from "../pages/Sewa/PaymentReportMonthly";
import ArrearsByWeek from "../pages/Sewa/ReportArrearsWeek";
import ArrearsByMonth from "../pages/Sewa/ReportArrearsMonthly";
import DBLKByMonth from "../pages/Sewa/DBLKMonthlyReport";
import UserManagementForm from "../pages/UserManagementForm";
import LandingSewa from "../pages/Sewa/LandingSewa";
import QR from "../pages/Sewa/QR";
import Chat from "../pages/Chat";
import AgentUnitAssignmentPage from "../pages/Sewa/AgentUnitAssignmentPage";
import SewaBillsUploaderPage from "../pages/SewaAgentCustomerUploader";

export const SewaRoutes = [
  <Route path="/" element={<LandingSewa />} />,
  <Route path="/dashboard" element={<LandingSewa />} />,
  <Route path="/data-penghuni/:zoneId" element={<Zones />} />,
  <Route path="/chat" element={<Chat />} />,
  <Route path="/laporan-caj/bulanan" element={<ChargesReport />} />,
  <Route path="/laporan-bayaran/harian" element={<PaymentByDay />} />,
  <Route path="/laporan-bayaran/mingguan" element={<PaymentByWeek />} />,
  <Route path="/laporan-bayaran/bulanan" element={<PaymentByMonth />} />,
  <Route path="/laporan-tunggakan/mingguan" element={<ArrearsByWeek />} />,
  <Route path="/laporan-tunggakan/bulanan" element={<ArrearsByMonth />} />,
  <Route path="/laporan-bulanan-dbkl" element={<DBLKByMonth />} />,
  <Route path="/kpi-pegawai-hasil" element={<KPIRevenue />} />,
  <Route path="/rampasan-tamat-kontrak" element={<Rampasan />} />,
  <Route path="/admin" element={<UserManagementForm />} />,
  <Route path="/muat-naik" element={<SewaBillsUploaderPage />} />,
  <Route path="/qr-kod" element={<QR />} />,
  <Route path="/admin/agent-units" element={<AgentUnitAssignmentPage />} />,
];